// Standup hero — Monstera-green band with greeting, narrative sub, and 3 metrics.

type HeroProps = {
  firstName: string;
  timestamp: string; // pre-formatted, e.g. "Friday, April 17 · 8:14 am"
  needsYou: number;
  draftsReady: number;
  autoHandled: number;
};

export function Hero({ firstName, timestamp, needsYou, draftsReady, autoHandled }: HeroProps) {
  const total = needsYou + draftsReady + autoHandled;

  const subCopy = buildSubCopy(total, autoHandled, needsYou);

  return (
    <section className="hero">
      <div className="wrap">
        <div className="hero-grid">
          <div>
            <div className="eyebrow">{timestamp}</div>
            <h1 className="display h1" style={{ margin: '14px 0 0' }}>
              Good morning, <span className="accent">{firstName}</span>.
            </h1>
            <p className="sub">{subCopy}</p>
          </div>
          <div className="hero-metrics">
            <div className="metric">
              <div className="n">{needsYou}</div>
              <div className="l">Needs you</div>
              <div className="t">Judgement calls</div>
            </div>
            <div className="metric">
              <div className="n">{draftsReady}</div>
              <div className="l">Ready to fly</div>
              <div className="t">Drafts awaiting send</div>
            </div>
            <div className="metric">
              <div className="n">{autoHandled}</div>
              <div className="l">Already handled</div>
              <div className="t">Closed while you slept</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function buildSubCopy(total: number, handled: number, needs: number): string {
  if (total === 0) {
    return "Your inbox is quiet — no new threads since you last checked.";
  }
  if (needs === 0) {
    return `${total} conversation${total === 1 ? '' : 's'} came in. None need a decision — everything is either drafted or already closed.`;
  }
  const handledClause = handled > 0 ? ` I already handled ${handled}.` : '';
  return `${total} conversation${total === 1 ? '' : 's'} came in.${handledClause} ${needs} need${needs === 1 ? 's' : ''} a human. Here's what's waiting.`;
}
